import { AccessDenied } from '@/components/ui/access-denied';
import { useAccessControl } from '@/hooks/useAccessControl';
import { MaintenanceSchedulerModule } from '@/modules/system-controls/maintenance-scheduler';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/maintenance/')({
  component: MaintenanceSchedulerPage,
});

function MaintenanceSchedulerPage() {
  const { canAccessMaintenanceScheduler } = useAccessControl();

  if (!canAccessMaintenanceScheduler) {
    return <AccessDenied />;
  }

  return <MaintenanceSchedulerModule />;
}
